import React from "react";
import PropTypes from "prop-types";
import ValidationTicketItem from "./ValidationTicketItem";
import moment from "moment-timezone";

import {
  messageResultCode,
  getBuyerTypeName,
  getBuyerTypeColor,
  getNameVenueORExtra,
  getPromotionName,
  getPromotionColor,
  validationModes,
  getEventStartDate,
  getEventEndDate,
} from "../../utils/verifier.utils";
import { FormattedMessage } from "react-intl";

class ValidationResult extends React.Component {
  state = {};

  constructor(props) {
    super(props);

    if (this.props.currentValidation) {
      this.state = { validationDetails: this.props.currentValidation[0] };
    }

    this.handleChangeValidationDetails = this.handleChangeValidationDetails.bind(
      this
    );
    this.handleIsActive = this.handleIsActive.bind(this);
    this.handleMessageResultCode = this.handleMessageResultCode.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentValidations) {
      this.setState({
        validationDetails: nextProps.currentValidations[0],
      });
    }
  }

  handleChangeValidationDetails(validation) {
    console.log("handleChangeValidationDetails");
    this.setState({
      validationDetails: validation,
    });
  }

  handleForce(validation, partialValidations) {
    let validationRequest = {};

    if (this.props.barcode && this.props.barcode.match(/^SGUP[0-9]/)) {
      validationRequest = {
        verifierId: this.props.verifierId,
        validationMode: validationModes.override,
        barcode: this.props.barcode,
      };
    } else {
      validationRequest = {
        ticketGroup: validation.ticketGroup,
        verifierId: this.props.verifierId,
        validationMode: validationModes.override,
        ticketId: validation.ticketId,
      };
    }

    if (partialValidations)
      validationRequest.numTicketsToValidate = partialValidations;
    this.props.forceValidation(validationRequest);
  }

  handleIsActive(validation) {
    if (validation === this.state.validationDetails) {
      return "active";
    } else {
      return "";
    }
  }

  handleMessageResultCode({ resultCode, buyerTypeId }) {
    if (resultCode === 200) {
      if (buyerTypeId) {
        return getBuyerTypeName(buyerTypeId, resultCode);
      }
    } else if (resultCode === 203) {
      return messageResultCode(resultCode);
    } else if (resultCode > 600 && resultCode < 609) {
      return messageResultCode(resultCode);
    }
    return messageResultCode(resultCode);
  }

  render() {
    let ticketId,
      reservationId,
      buyerType,
      buyerTypeColor,
      scanDate,
      promotionId,
      promotionName,
      promotionColor,
      venueCapacityName,
      buyerTypeName,
      numValidatedTickets,
      numTickets,
      startDateTime,
      endDatetime;

    const { validationDetails } = this.state;

    if (validationDetails !== undefined) {
      ticketId = validationDetails.ticketId;
      reservationId = validationDetails.reservationId;
      buyerType = validationDetails.buyerTypeId;
      scanDate = validationDetails.scanDate;
      promotionId = validationDetails.promotionId;
      if (promotionId) {
        promotionName = getPromotionName(promotionId);
        promotionColor = getPromotionColor(promotionId);
      }
      venueCapacityName = getNameVenueORExtra(validationDetails);
      if (buyerType) {
        buyerTypeName = getBuyerTypeName(buyerType);
        buyerTypeColor = getBuyerTypeColor(buyerType);
      }
      numValidatedTickets = validationDetails.numValidatedTickets;
      numTickets = validationDetails.numTickets;
      startDateTime = getEventStartDate(validationDetails.eventId);
      endDatetime = getEventEndDate(validationDetails.eventId);
    }

    const resultTicketItem = (
      <ValidationTicketItem
        venueCapacityName={venueCapacityName}
        buyerTypeName={buyerTypeName}
        buyerTypeColor={buyerTypeColor}
        promotionId={promotionId}
        promotionColor={promotionColor}
        promotionName={promotionName}
        scanDate={scanDate}
        ticketId={ticketId}
        reservationId={reservationId}
        numTickets={numTickets}
        numValidatedTickets={numValidatedTickets}
        startDateTime={startDateTime}
        endDatetime={endDatetime}
      />
    );
    const timeZone = JSON.parse(sessionStorage.getItem("timeZone"));

    return (
      <div>
        {this.props.currentValidations ? (
          <div>
            <div className="result">
              <h1>
                <FormattedMessage
                  defaultMessage="Resultado de la validación"
                  id="title.result.validation"
                />{" "}
                <span className="pull-right hidden-xs">
                  {scanDate && moment(scanDate).tz(timeZone).format("HH:mm:ss")}
                </span>
              </h1>
              {this.props.currentValidations.map((validation, index) => (
                <div
                  ref={(input) => (this.detailsPill = input)}
                  onClick={() => this.handleChangeValidationDetails(validation)}
                  key={index}
                  style={
                    buyerTypeColor && validation.resultCode === 200
                      ? { backgroundColor: buyerTypeColor }
                      : {}
                  }
                  className={
                    validation.resultCode === 200 ||
                    validation.resultCode === 203 //203 for exit mode on validator
                      ? `bg-success media ${this.handleIsActive(validation)}`
                      : `bg-danger media ${this.handleIsActive(validation)}`
                  }
                >
                  {validation.validationMode === validationModes.override && (
                    <div className="media-left">
                      <div>
                        <span className="icon-own-forced-ticket"> </span>
                      </div>
                    </div>
                  )}
                  <div className="media-body">
                    <h4 className="media-heading">
                      {this.handleMessageResultCode(validation)}
                    </h4>
                    <p>{getNameVenueORExtra(validation)}</p>
                  </div>
                  {validation.promotionId && (
                    <div className="media-right promo">
                      <div>
                        <span
                          className="icon-own-star"
                          style={
                            promotionColor ? { color: promotionColor } : {}
                          }
                        >
                          {" "}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="details">
              <h1>
                <FormattedMessage
                  defaultMessage="Detalles de entrada"
                  id="title.details.ticket"
                />
              </h1>
              {resultTicketItem}
            </div>
          </div>
        ) : (
          <div />
        )}

        <div className="row ">
          <div className="col-md-12 text-center">
            {validationDetails &&
              validationDetails.resultCode !== 200 &&
              validationDetails.resultCode !== 203 && (
                <button
                  className="btn btn-validate btn-xs-block"
                  type="button"
                  onClick={() =>
                    this.handleForce(
                      this.props.currentValidations[0],
                      this.props.currentValidations[0].numPartialValidation
                    )
                  }
                >
                  <FormattedMessage
                    defaultMessage="Force Validation"
                    id="button.force.validation"
                  />
                </button>
              )}
          </div>
        </div>
      </div>
    );
  }
}

ValidationResult.propTypes = {
  forceValidation: PropTypes.func.isRequired,
  currentValidation: PropTypes.array,
};

export default ValidationResult;
